export function hideContactError(id) {
  try {
    const errorMsg = document.getElementById(id);
    errorMsg.style.display = 'none';
    errorMsg.removeAttribute('role');
  } catch (e) {
    return undefined;
  }
  return undefined;
}

function emailVal(email) {
  return /^[\w!#$%&*+/=?`{|}~^-]+(?:\.[\w!#$%&*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,32}$/.test(email);
}

export function validatePhone(phoneRef) {
  hideContactError('phone-empty-error');
  hideContactError('phone-validation-error');
  const regex = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
  if (phoneRef.current.value.trim().length === 0) {
    return ('phone-empty-error');
  }
  if (!regex.test(phoneRef.current.value)) {
    return ('phone-validation-error');
  }
  return undefined;
}

export function validateEmail(emailRef) {
  hideContactError('email_empty_error_message');
  hideContactError('email_error_message');
  hideContactError('email_invalid');
  if (emailRef.current.value.trim().length === 0) {
    // ShowContactError("email_empty_error_message");
    return ('email_empty_error_message');
  } if (emailRef.current.value.length > 50) {
    return ('email_error_message');
  } if (!emailVal(emailRef.current.value)) {
    return ('email_invalid');
  }
  return undefined;
}

export function validateName(nameRef) {
  hideContactError('name-required');
  hideContactError('name-length-error');
  const name = nameRef.current.value;
  if (name.length === 0) {
    return ('name-required');
  } if (name.length > 50) {
    return ('name-length-error');
  }
  return undefined;
}

export function validateDescriptionBody(bodyref) {
  if (bodyref.current.value.trim().length === 0) {
    // ShowContactError("description_empty_error_message",true);
    return ('description_empty_error_message');
  }
  hideContactError('description_empty_error_message');

  if (bodyref.current.value.length > 1500) {
    // ShowContactError("description_error_message", true);
    return ('description_error_message');
  }
  hideContactError('description_error_message');
  return undefined;
}

export function ShowContactError(id) {
  const errorElement = document.getElementById(id);
  const fieldset = errorElement.closest('fieldset');
  if (!fieldset) {
    errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  const legend = fieldset.querySelector('legend');
  if (legend) {
    legend.scrollIntoView({ behavior: 'smooth', block: 'start' });
    legend.focus?.({ preventScroll: true });
  } else {
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'start' });
    fieldset.focus?.({ preventScroll: true });
  }
}

export function showErrorFromList(errorList, widget) {
  if (errorList !== undefined && typeof errorList === 'object' && errorList.length > 0) {
    errorList.forEach((error) => {
      $(`#${error}`).show();
    });

    ShowContactError(errorList[0], widget);
  }
}
